import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, TooltipPortal } from '@/components/ui/tooltip';

interface SelectionButtonsProps {
  options: string[];
  onSelect: (option: string) => void;
  disabled?: boolean;
}

export const SelectionButtons = ({ options, onSelect, disabled }: SelectionButtonsProps) => {
  return (
    <TooltipProvider delayDuration={0}>
      <div className="flex flex-col gap-3 mt-4 max-h-64 overflow-y-auto">
        {options.map((option, idx) => {
          // Extract option name from "- Option Name (description)" format
          const cleanOption = option.replace(/^[-*]\s*/, '').trim();
          const [name, description] = cleanOption.split(/\s*\(/);
          const desc = description?.replace(')', '').trim();
          
          return (
            <Tooltip key={idx}>
              <TooltipTrigger asChild>
                <Button
                  onClick={() => onSelect(cleanOption)}
                  disabled={disabled}
                  variant="outline"
                  className="w-full py-3 px-4 text-left justify-start hover:bg-primary hover:text-primary-foreground transition-colors min-h-[48px]"
                >
                  <span className="font-medium text-base leading-relaxed truncate">{name}</span>
                </Button>
              </TooltipTrigger>
              <TooltipPortal>
                <TooltipContent side="left" sideOffset={12} className="z-[10000] max-w-md bg-white text-black border border-gray-200 shadow-2xl p-3 rounded-lg">
                  <p className="text-sm leading-relaxed break-words whitespace-normal">{cleanOption}</p>
                </TooltipContent>
              </TooltipPortal>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
};
